import Cookies from 'js-cookie'

const TokenKey = 'Access-Token'

export function getToken() {
  return Cookies.get(TokenKey)
  // 获取token
  // return localStorage.getItem(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
  // 添加token
  // return localStorage.setItem(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
  // 删除token
  // return localStorage.removeItem(TokenKey)
}
